<template>
  <div v-if="user != ''" class="wrapper">
    <HTMLHeader></HTMLHeader>

    <div class="subpage-head-image" style="background-image: url('assets/img/subpage-head.jpg');">
      <div class="container">
        <h1>
          HATÁR Adminisztráció
        </h1>
      </div>
    </div>

    <section>
      <div class="container">
        <h1>HATÁR Adminisztráció kliens program</h1>
        <a href="assets/files/HatarKliens.application">
          <button type="button" class="button">
            <i class="fa fa-download"></i>
            Letöltés (Windows)
          </button>
        </a>

        <h4>Telepítéshez szükséges összetevők</h4>
        <small>
          <ul>
            <li><a>Windows Installer 4.5</a></li>
            <li><a>.NET Framework 3.5 SP1</a></li>
            <li><a>Microsoft Data Access Components 2.8</a></li>
            <li><a>SAP Crystal Reports Runtime Engine for .NET Framework</a></li>
          </ul>
        </small>

        <h4>Hibaelhárítás</h4>
        <small>
          <div class="row">
            <div class="col-sm-6">
              <strong>Hiba</strong><br>
              "Az alkalmazást nem lehet telepíteni vagy futtatni, mert ehhez előbb telepíteni kell a globális szerelvény-gyorsítótárban (GAC) a(z) CrystalDecisions.ReportAppServer.CommonObjectMode I - verzió 13.0.2000.0 szerelvényt."
            </div>
            <div class="col-sm-6">
              <strong>Megoldás</strong><br>
              A következő két fájlt töltsd le és telepítsd őket:
              <ol>
                <li><a href="assets/files/CRRuntime_32bit_13_0_4.msi" target="_blank">CRRuntime_32bit_13_0_4.msi</a></li>
                <li><a href="assets/files/CRRuntime_64bit_13_0_4.msi" target="_blank">CRRuntime_64bit_13_0_4.msi</a></li>
              </ol>
              Ezután próbáld meg újra a HATÁR telepítést.
            </div>
          </div>
        </small>
      </div>
    </section>

    <HTMLFooter></HTMLFooter>
    <ProfileMenu></ProfileMenu>
  </div>
</template>
<script>
import Vue from 'vue';
import HTMLHeader from './tpl_header.vue';
import HTMLFooter from './tpl_footer.vue';
import ProfileMenu from './tpl_profile_menu.vue';

export default {
  components: {
    HTMLHeader,
    HTMLFooter,
    ProfileMenu
  },
  data: function() {
    return {
      sent: false
    }
  },
  mounted: function() {
    var _this = this;
    Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);

      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });
  },
  methods: {
  }
}

</script>




// WEBPACK FOOTER //
// hatar_admin.vue?777138dc